import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitQuote = (data) => axios.post(`${API}/quotes`, data);
export const submitCarrier = (data) => axios.post(`${API}/carriers`, data);
export const submitMessage = (data) => axios.post(`${API}/messages`, data);

export const getSubmissions = (key) =>
  axios.get(`${API}/admin/submissions`, { headers: { Authorization: `Bearer ${key}` } });

export const downloadExport = async (key) => {
  const res = await axios.get(`${API}/admin/export`, {
    headers: { Authorization: `Bearer ${key}` },
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = "elt_submissions.xlsx";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
